import z from 'zod';

export const TREATMENT_APPROACHES = [
    'AEDP',
    'ACT',
    'ATTACHMENT_BASED',
    'BOWEN_FAMILY',
    'CBT',
    'CPT',
    'CRAFT',
    'CFT',
    'CREATIVE',
    'CULTURALLY_SENSITIVE',
    'DBT',
    'EFT',
    'EXPERIENTIAL',
    'ERP',
    'EMDR',
    'IMAGO',
    'ISTDP',
    'IFS',
    'IPT',
    'MBCT',
    'MI',
    'NARRATIVE',
    'PCIT',
    'PERSON_CENTERED',
    'PROLONGED_EXPOSURE',
    'PSYCHODYNAMIC',
    'REBT',
    'SFBT',
    'SOMATIC',
    'SPIRITUAL',
    'STRENGTH_BASED',
    'STRUCTURAL_FAMILY',
    'GOTTMAN',
    'TRAUMA_FOCUSED',
] as const;

export type TreatmentApproach = (typeof TREATMENT_APPROACHES)[number];
export const treatmentApproachesSchema = z.array(z.enum(TREATMENT_APPROACHES));
